import { render, staticRenderFns } from "./SkeletonOrderProduct.vue?vue&type=template&id=a1645080"
import script from "./SkeletonOrderProduct.vue?vue&type=script&lang=js"
export * from "./SkeletonOrderProduct.vue?vue&type=script&lang=js"
import style0 from "./SkeletonOrderProduct.vue?vue&type=style&index=0&id=a1645080&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports